import { useQuery } from '@apollo/client';
import { getSignRequestAttachments } from './query';
import { useEsigning } from '../../components/EsigningProvider';
export const useGetSignRequestAttachments = () => {
    var _a, _b;
    const { documentId } = useEsigning();
    const { data, loading, error } = useQuery(getSignRequestAttachments, {
        variables: {
            id: documentId,
        },
    });
    const attachments = ((_b = (_a = data === null || data === void 0 ? void 0 : data.document) === null || _a === void 0 ? void 0 : _a.lastSignRequest) === null || _b === void 0 ? void 0 : _b.attachments) || [];
    return {
        loading,
        error,
        attachments,
    };
};
